import {Get_ScrutinyDetails} from '../constants/ActionTypes'

const INIT_STATE = {
    ScrutinyDetails: null,
    loading: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case Get_ScrutinyDetails:
            return {
                ScrutinyDetails: action.body,
                loading :false
            }
        default:
            return state;
    }
}